<svelte:options customElement={{tag: 'ia-dashboard'}}/>
<script>
    import {CommonStyles, MainPreloader, Toast} from "@intellectability/platform-common/sv";
    import {userSecurity} from "@intellectability/platform-common/sv/state";
    import {configCheck} from "@intellectability/platform-common/utils";

    let getConfigValue = $derived(configCheck(userSecurity.applicationConfig));

    import {fade} from "svelte/transition";
    import {Dashboard} from "../../../Pages/index.js";

    let styleLoading = $state(false);
    let env_type = $derived(getConfigValue("env_type"));

    document.title = "Dashboard";

</script>

<main class="mb-4">
    <CommonStyles
            env={env_type}
            onload={() => styleLoading = false}
            onerror={() => styleLoading = false}
    />
    {#if styleLoading}
        <MainPreloader></MainPreloader>
    {:else}
        <div transition:fade={{duration: 250}}>
            <Dashboard></Dashboard>
        </div>
    {/if}
    <Toast/>
</main>